export const INTERACTION_MODAL_DIALOG_CLASS = 'modal-dialog-centered interaction-confirm-modal';

export const AI_TRAINING_MODAL_DIALOG_CLASS = `${INTERACTION_MODAL_DIALOG_CLASS} ai-training-modal-dialog`;

export const BUILDER_ALTERNATIVES_MODAL_DIALOG_CLASS = `${INTERACTION_MODAL_DIALOG_CLASS} builder-alternatives-modal-dialog`;

export const ADD_WORKOUT_MODAL_DIALOG_CLASS = `${INTERACTION_MODAL_DIALOG_CLASS} add-workout-modal-dialog`;

export const EDIT_WORKOUT_CHOICE_MODAL_DIALOG_CLASS = `${INTERACTION_MODAL_DIALOG_CLASS} edit-workout-choice-modal-dialog`;

export const SAVE_BLOCK_TEMPLATE_MODAL_DIALOG_CLASS = `${INTERACTION_MODAL_DIALOG_CLASS} save-block-template-modal-dialog`;

export const PROGRAM_CLIENTS_MODAL_DIALOG_CLASS = `${INTERACTION_MODAL_DIALOG_CLASS} program-clients-modal-dialog`;

export const INTERACTION_MODAL_OPTIONS = {
    animated: true,
    backdrop: true,
    keyboard: true,
    ignoreBackdropClick: true,
} as const;

/** No animation when swapping one interaction modal for another. */
export const INTERACTION_MODAL_SWAP_OPTIONS = {
    ...INTERACTION_MODAL_OPTIONS,
    animated: false,
} as const;
